module.exports = __webpack_public_path__ + "static/ClickedOthers-065bac286bc899a5897843eb0cc84c2b.png";